import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'settings/environment';
//import Logo from '../../../ui-component/Logo';
import React from 'react';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={'/'}>
        <img
            alt='Logo'
            src={`${config.rutaImagenes}/logos/logo.png`}
            height='52'
            width='52'
        />
        DOP JUMILLA
    </ButtonBase>
);

export default LogoSection;
